<script setup lang="ts">
import type { TBreadcrumbItem } from "./types";

import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const breadcrumb = computed<TBreadcrumbItem[]>(() => {
  const breadcrumbMeta = route.meta.breadcrumb;

  if (typeof breadcrumbMeta === "function") {
    return breadcrumbMeta(route) as TBreadcrumbItem[];
  }

  return (breadcrumbMeta as TBreadcrumbItem[]) || [];
});
</script>

<template>
  <div class="max-h-16 py-4 pr-4 pl-6 flex items-center gap-2 border-b">
    <span><i class="pi pi-home text-surface-400 !leading-none" /></span>

    <template :key="item.to" v-for="(item, index) in breadcrumb">
      <RouterLink
        :to="item.to"
        class="flex items-center gap-2 hover:text-surface-950 dark:hover:text-surface-0 font-medium"
        :class="
          index < breadcrumb.length - 1
            ? 'text-surface-400 font-normal'
            : 'text-surface-950 dark:text-surface-0 font-medium'
        "
        v-if="item.to"
      >
        <span class="leading-none">
          {{ item.label }}
        </span>

        <span><i class="pi pi-chevron-right !text-xs !leading-none" v-if="index < breadcrumb.length - 1" /></span>
      </RouterLink>

      <div
        class="flex items-center gap-2"
        :class="
          index < breadcrumb.length - 1
            ? 'text-surface-400 font-normal'
            : 'text-surface-950 dark:text-surface-0 font-medium'
        "
        v-else
      >
        <span class="leading-none">
          {{ item.label }}
        </span>

        <span><i class="pi pi-chevron-right !text-xs !leading-none" v-if="index < breadcrumb.length - 1" /></span>
      </div>
    </template>
  </div>
</template>
